export default {
    index: {
        meta: {
            title: "Index"
        },
        home: "Home",
        about: "About US"
    }
}